"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAllDislikedTracks = exports.selectDislikedTracks = exports.selectNextPendingReactionTask = exports.selectReactionSendInProgress = exports.selectInProgressReactions = exports.selectPendingReactions = void 0;
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
function selectPendingReactions(state) {
    return state.reactions.pending;
}
exports.selectPendingReactions = selectPendingReactions;
function selectInProgressReactions(state) {
    return state.reactions.inProgress;
}
exports.selectInProgressReactions = selectInProgressReactions;
function selectReactionSendInProgress(state) {
    return selectInProgressReactions(state).length > 0;
}
exports.selectReactionSendInProgress = selectReactionSendInProgress;
function selectNextPendingReactionTask(state) {
    var inProgress = selectInProgressReactions(state);
    var pending = state.reactions.pending.filter(function (task) { return !inProgress.find(function (inProgressTask) { return (0, lodash_isequal_1.default)(task, inProgressTask); }); });
    return pending[0];
}
exports.selectNextPendingReactionTask = selectNextPendingReactionTask;
function selectDislikedTracks(state, streamId) {
    var pendingRestores = selectPendingReactions(state).filter(function (item) { return item.streamId === streamId && item.type === "restore-dislike"; });
    var dislikes = state.reactions.disliked
        .filter(function (item) { return item.streamId === streamId; })
        .filter(function (item) {
        return !pendingRestores.find(function (restore) { return item.streamId === restore.streamId && item.id === restore.id; });
    });
    var pendingDislikes = selectPendingReactions(state).filter(function (item) { return item.streamId === streamId && item.type === "dislike"; });
    return (0, lodash_uniqby_1.default)(__spreadArray(__spreadArray([], __read(dislikes), false), __read(pendingDislikes), false), "id").map(function (item) { return item.id; });
}
exports.selectDislikedTracks = selectDislikedTracks;
function selectAllDislikedTracks(state) {
    return state.reactions.totalDislikes;
}
exports.selectAllDislikedTracks = selectAllDislikedTracks;
//# sourceMappingURL=reactions.js.map